export default {
  title: 'Rapport équipe commerciale',
  fields: {
    name: 'Nom',
    area: 'Zone',
    signed: 'Signé',
    live: 'En ligne',
  },
  buttons: {
    download_report: 'Télécharger le rapport',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données, veuillez rafraîchir la page',
  },
};
